import React from 'react';
import { Spinner } from 'components/UI';
import styles from './ProductivityDetailTable.module.scss';

interface ProductivityData {
    staff: string;
    totalAppointments: number;
    totalPets: number;
    avgDuration: number;
    hoursScheduled: number;
    availability: number;
    utilization: number;
}

interface ProductivityDetailTableProps {
    loading: boolean;
    data: ProductivityData[] | null;
}

export const ProductivityDetailTable: React.FunctionComponent<ProductivityDetailTableProps> = props => {
    const formatDuration = (minutes: number) => {
        return `${minutes} min`;
    };

    const formatPercentage = (percent: number) => {
        return `${percent.toFixed(1)}%`;
    };

    return (
        <div className={styles.root}>
            <div className={styles.tableWrapper}>
                <table className={styles.table}>
                    <thead className={styles.header}>
                        <tr>
                            <th className={styles.headerCell}>Staff</th>
                            <th className={styles.headerCell}>Total Appointments</th>
                            <th className={styles.headerCell}>Total Pets</th>
                            <th className={styles.headerCell}>Avg Duration</th>
                            <th className={styles.headerCell}>Hours Scheduled</th>
                            <th className={styles.headerCell}>Availability</th>
                            <th className={styles.headerCell}>Utilization</th>
                        </tr>
                    </thead>
                    <tbody className={styles.body}>
                        {props.loading ? (
                            <tr>
                                <td
                                    colSpan={7}
                                    className={styles.loadingCell}
                                >
                                    <Spinner className={styles.spinner} />
                                </td>
                            </tr>
                        ) : (
                            props.data?.map((item, index) => (
                                <tr
                                    key={index}
                                    className={styles.row}
                                >
                                    <td className={styles.cell}>{item.staff}</td>
                                    <td className={styles.cell}>{item.totalAppointments}</td>
                                    <td className={styles.cell}>{item.totalPets}</td>
                                    <td className={styles.cell}>{formatDuration(item.avgDuration)}</td>
                                    <td className={styles.cell}>{item.hoursScheduled}</td>
                                    <td className={styles.cell}>{formatPercentage(item.availability)}</td>
                                    <td className={styles.cell}>{formatPercentage(item.utilization)}</td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default ProductivityDetailTable;
